// removed by extract-text-webpack-plugin
module.exports = {"base":"PaginationArrowButton_base--xHf0R","base__locked":"PaginationArrowButton_base__locked--v0PHw","baseLocked":"PaginationArrowButton_base__locked--v0PHw","icon":"PaginationArrowButton_icon--3N1Tz","icon__back":"PaginationArrowButton_icon__back--3fJzW","iconBack":"PaginationArrowButton_icon__back--3fJzW","icon__forward":"PaginationArrowButton_icon__forward--MpAuz","iconForward":"PaginationArrowButton_icon__forward--MpAuz"};


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/PaginationArrowButton/PaginationArrowButton.scss
// module id = 2365
// module chunks = 11